import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBottombarHiddenBottomWide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"bottombar-hidden-bottom-wide"} maskId="square-filled-radius-0-stroke-1-IconBottombarHiddenBottomWide"><path fillRule="evenodd" clipRule="evenodd" d="M22 20H2V4H22V20ZM6 16H18V15H6V16Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBottombarHiddenBottomWide;
